import React from 'react'
import { shallow } from 'enzyme'
import { PayrollInfo } from '../../sections/PayrollInfo'

describe('PayrollInfo', () => {
  let wrapper, props, instance

  beforeAll( () => {
    props = {
      data: {
        loan: {
          rid: 1,
          businesses: [
            {
              borrowerType: 'oc',
              questions: [
                {
                  number: 700
                }
              ],
              answers: [{
                questionNumber: 700,
                value: 'hello'
              }]
            }
          ]
        },
        section: 'PayrollInfo',
        ccustomerService: true
      }
    }
    wrapper = shallow(<PayrollInfo {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe('#questionNumbers', () => {
    it('should return obj', () => {
      const { questionNumbers } = instance
      const keys = Object.keys(questionNumbers)

      expect(typeof questionNumbers).toBe('object')
      expect(keys).toContain('700')
      expect(keys).toContain('705')
      expect(keys).toContain('706')
    })
  })

  describe('#getObjectRows', () => {
    it('should return obj', () => {
      const { getObjectRows } = instance

      expect(getObjectRows()).toBeTruthy()
    })
  })

  describe('#getHelpers', () => {
    it('should return obj', () => {
      const { getHelpers } = instance

      expect(getHelpers().questions).toBeTruthy()
    })
  })
})